import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { TabbedContent, TabbedContentProps } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { classes } from './TabbedContent.visual.st.css';

const items = [0, 1, 2, 4].map((i) => ({ id: `${i}`, title: `Title ${i}` }));

visualize('TabbedContent', () => {
  const TabbedContentVisual: React.FC<
    { isMobile?: boolean } & Partial<TabbedContentProps>
  > = ({ isMobile = false, ...props }) => {
    return (
      <TPAComponentsProvider value={{ mobile: isMobile }}>
        <TabbedContent items={items} activeTabIndex={0} {...props}>
          {(id) => {
            return <div>This is tab id {id}</div>;
          }}
        </TabbedContent>
      </TPAComponentsProvider>
    );
  };

  story('basic', () => {
    snap('default', <TabbedContentVisual />);
    snap('render different tab', <TabbedContentVisual activeTabIndex={1} />);
    snap('mobile', <TabbedContentVisual isMobile />);
  });

  story('wired', () => {
    snap('default', <TabbedContentVisual className={classes.root} />);
    snap(
      'render different tab',
      <TabbedContentVisual className={classes.root} activeTabIndex={1} />,
    );
    snap('mobile', <TabbedContentVisual className={classes.root} isMobile />);
  });
});
